import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.Toolbar', {
    toolbarValidationText: 'Enter a name for the approval workflow',
    disconnectionWarningText: 'The workflow is readonly since the organisation is disconnected from {integrationName}',
    retiredWarningText: 'The workflow is readonly since the organisation is retired',
    expiredWarningText: "The workflow is readonly since the organisation's subscription has expired.",
    trialExpiredWarningText: "The workflow is readonly since the organisation's trial period has expired.",
    modified: 'Modified',
    by: 'by',
    on: 'on',
});
